
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/Users/nestoras/Documents/GitHub/colorize-frontend/sentry.client.config.ts")
            }
          });